import parseUserJson from "./admin/parseUserJson";
import { hasData } from "./hasData";

export function idInJson(json,id) {
    if (!hasData(json) || !hasData(id)) return false
    const pjson = parseUserJson(json)
    return pjson?.filter(x => x?.id?.toString() === id?.toString()).length > 0;
  }